import { render, staticRenderFns } from "./ClaimStatus.vue?vue&type=template&id=72765d6f&"
import script from "./ClaimStatus.vue?vue&type=script&lang=js&"
export * from "./ClaimStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports